export default __webpack_public_path__ + "static/media/albania.e1401718.svg";